import { ReebeloStoreT } from '@lambda/reebelo';
import i18n from '@/settings/i18n';
import { CategoryOptionT } from './types';

const t = i18n.init('business');

const getOptions = () => {
  const macbook: CategoryOptionT = {
    value: 'macbooks',
    title: t`MacBook`,
    categoryPk: '05t394s0h4e1',
    brandId: 'brd-merms4aeBz6hYtWCral7Vps',
  };

  const laptop: CategoryOptionT = {
    value: 'laptops',
    title: t`Laptop`,
    categoryPk: '05t394s0h4e1',
  };

  const iphone: CategoryOptionT = {
    value: 'iphones',
    title: t`iPhone`,
    categoryPk: '02h610t3d104',
    brandId: 'brd-merms4aeBz6hYtWCral7Vps',
  };

  const samsungGalaxy: CategoryOptionT = {
    value: 'samsung-galaxy',
    title: t`Samsung Galaxy`,
    categoryPk: '02h610t3d104',
    brandId: 'brd-mermsajbpweiPlGcvljUgFH',
  };

  return {
    'reebelo-us': [macbook, laptop, iphone, samsungGalaxy],
    'reebelo-ca': [macbook, laptop, iphone, samsungGalaxy],
    'reebelo-au': [macbook, laptop, iphone, samsungGalaxy],
    'reebelo-nz': [macbook, laptop, iphone, samsungGalaxy],
    'reebelo-uk': [macbook, laptop, iphone, samsungGalaxy],
    'reebelo-fr': [macbook, laptop, iphone, samsungGalaxy],
    'reebelo-de': [macbook, laptop, iphone, samsungGalaxy],
    'reebelo-es': [macbook, laptop, iphone, samsungGalaxy],
    'reebelo-it': [macbook, laptop, iphone, samsungGalaxy],
    'reebelo-se': [macbook, laptop, iphone, samsungGalaxy],
    quista: [macbook, laptop, iphone, samsungGalaxy],
  } as Partial<Record<ReebeloStoreT, CategoryOptionT[]>>;
};

export { getOptions };
export const CATEGORY_OPTIONS = getOptions();
